
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Pancreatic_neuroendocrine_tumors",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Pancreatic_neuroendocrine_tumors.vue